import { format, parseISO, subMinutes } from 'date-fns';
import {
  utcToZonedTime,
} from 'date-fns-tz';

export const formatDateTime = (datetimeVal, selectedFormat) => {
  try {
    if (!datetimeVal) {
      return '';
    }

    if (typeof datetimeVal === 'string') {
      return format(parseISO(datetimeVal), selectedFormat);
    }

    return format(datetimeVal, selectedFormat);
  } catch (error) {
    return '';
  }
};

export const formatInZonedTime = (datetimeVal, selectedFormat, timezone) => {
  if (!timezone) {
    return formatDateTime(datetimeVal, selectedFormat);
  }

  try {
    if (!datetimeVal) {
      return '';
    }

    const zonedDate = utcToZonedTime(datetimeVal, timezone);

    const subtractedZonedDate = subMinutes(zonedDate, zonedDate.getTimezoneOffset());

    return format(subtractedZonedDate, selectedFormat);
  } catch (error) {
    return '';
  }
};

export const convertDateInZonedTime = (datetimeVal, timezone) => {
  if (!datetimeVal) {
    return '';
  }

  try {
    const zonedDate = utcToZonedTime(datetimeVal, timezone);

    const subtractedZonedDate = subMinutes(zonedDate, zonedDate.getTimezoneOffset());
    return subtractedZonedDate;
  } catch (error) {
    return '';
  }
};

export const convertSystemDateToUTC = (datetimeVal) => {
  if (!datetimeVal) {
    return null;
  }

  const currentDateTime = new Date();

  datetimeVal.setHours(currentDateTime.getHours());
  datetimeVal.setMinutes(currentDateTime.getMinutes());
  datetimeVal.setSeconds(currentDateTime.getSeconds());

  return datetimeVal.toISOString();
};

export const getStartDateWithTime = (date) => {
  if (!date) {
    return null;
  }

  const _startDate = new Date(date);
  _startDate.setHours(0, 0, 0, 0);
  return _startDate;
};

export const getEndDateWithTime = (date) => {
  if (!date) {
    return null;
  }
  const _endDate = new Date(date);
  _endDate.setHours(23, 59, 59, 999);
  return _endDate;
};
// dateTimeUtls.js

export default {
  formatInZonedTime,
  formatDateTime
};
